import { motion } from 'framer-motion';
import { QuizQuestion } from '@shared/types';

interface YesNoInputProps {
  question: QuizQuestion;
  value: string;
  onChange: (value: string) => void;
  onAutoAdvance?: (value: string) => void;
}

export default function YesNoInput({ value, onChange, onAutoAdvance }: YesNoInputProps) {
  const handleSelect = (selectedValue: string) => {
    onChange(selectedValue);
    if (onAutoAdvance) {
      onAutoAdvance(selectedValue);
    }
  };

  const options = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
  ];

  return (
    <div className="grid grid-cols-2 gap-4">
      {options.map((option) => {
        const isSelected = value === option.value;
        
        return (
          <motion.button
            key={option.value}
            onClick={() => handleSelect(option.value)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={`
              py-2 px-4 rounded-lg transition-all text-lg font-semibold
              ${isSelected
                ? 'select-option-selected'
                : 'select-option'
              }
            `}
          >
            {option.label}
          </motion.button>
        );
      })}
    </div>
  );
}

